import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import useTableScroll from "../components/useTableScroll.js";
 
import { Mensaje } from '../components/mensajes';
import axios from "axios";
import moment from 'moment';
import {Dimmer} from "../components/spinner";
import { formatMoneda } from '../util/varios.js';


const CatalogoCompromisosUbicacion = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'N° COMPROMISO', textAlign: 'center' },
        { label: 'CONCEPTO', textAlign: 'center' },
        { label: 'MONTO', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idcompromiso.includes(target.value)
                            || x.concepto.toLowerCase().includes(target.value.toLowerCase())
                            || formatMoneda(x.montocompromiso.toString().replace(',', '').replace('.', ','), ',', '.', 2).includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarCompromisos = () => {
        let campos = "idcompromiso, concepto, montocompromiso, ubicacion, reversado";
        let id = props.proce === 0 ? props.ubicacion : 0;
        let nomtab = 'compromiso';
        let nomid = props.proce === 0 ? 'ubicacion' : 'reversado';
        let nomid2 = 'idefiscal';
        let id2 = props.idefiscal;
        let nomid3 = 'status';
        let id3 = props.status;
        let nomid4 = 'reversado';
        let id4 = 0;
        let endpoint = `${op.conexion}/api/consulta/modeli7?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${id2}&nomid3=${nomid3}&id3=${id3}&nomid4=${nomid4}&id4=${id4}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {

                setActivate(false);
                var data = []
                for (let i = 0; i < response.data.length; i++) {
                    data.push({
                        idcompromiso: response.data[i].idcompromiso,
                        tipo: response.data[i].tipo,
                        referencia: response.data[i].referencia,
                        fecha: response.data[i].fecha,
                        idproveedor: response.data[i].idproveedor,
                        idcoordinacion: response.data[i].idcoordinacion,
                        idefiscal: response.data[i].idefiscal,
                        concepto: response.data[i].concepto,
                        reversado: response.data[i].reversado,
                        montocompromiso: response.data[i].montocompromiso,
                        ubicacion: response.data[i].ubicacion,
                        status: response.data[i].status,
                        montoiva: response.data[i].montoiva,
                        fechafactura: response.data[i].fechafactura,
                        nrofactura: response.data[i].nrofactura,
                        nrocontrol: response.data[i].nrocontrol,
                        idusuario_crea: response.data[i].idusuario_crea,
                        fecha_crea: response.data[i].fecha_crea,
                        fecha_reverso: response.data[i].fecha_reverso,
                        idusuario_reversa: response.data[i].idusuario_reversa,
                        idtipopago: response.data[i].idtipopago,
                        iddatpresu: response.data[i].iddatpresu,
                    })
                }
                setRecords(data)
            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });

    }

    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const selectCompro = () => {

        var idcompromiso = values[0].idcompromiso;
        var tipo = values[0].tipo;
        var referencia = values[0].referencia;
        var fecha = values[0].fecha;
        var idproveedor = values[0].idproveedor;
        var idcoordinacion = values[0].idcoordinacion;
        var idefiscal = values[0].idefiscal;
        var concepto = values[0].concepto;
        var reversado = values[0].reversado;
        var montocompromiso = values[0].montocompromiso;
        var ubicacion = values[0].ubicacion;
        var status = values[0].status;
        var montoiva = values[0].montoiva;
        var fechafactura = values[0].fechafactura;
        var nrofactura = values[0].nrofactura;
        var nrocontrol = values[0].nrocontrol;
        var idusuario_crea = values[0].idusuario_crea;
        var fecha_crea = values[0].fecha_crea;
        var fecha_reverso = values[0].fecha_reverso;
        var idusuario_reversa = values[0].idusuario_reversa;
        var idtipopago = values[0].idtipopago;
        var iddatpresu = values[0].iddatpresu;

        blanquear();
        props.onHideAceptarCompromiso(idcompromiso, tipo, referencia, fecha, idproveedor, idcoordinacion, idefiscal, concepto, reversado, montocompromiso,
            ubicacion, status, montoiva, fechafactura, nrofactura, nrocontrol, idusuario_crea, fecha_crea, fecha_reverso, idusuario_reversa, idtipopago, iddatpresu);
        props.onHideCancelar();
    };

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setItemSelect(index);
        setActivo(false);

        var idcompromiso = recordsAfterPagingAndSorting()[index].idcompromiso;
        var tipo = recordsAfterPagingAndSorting()[index].tipo;
        var referencia = recordsAfterPagingAndSorting()[index].referencia;
        var fecha = recordsAfterPagingAndSorting()[index].fecha;
        var idproveedor = recordsAfterPagingAndSorting()[index].idproveedor;
        var idcoordinacion = recordsAfterPagingAndSorting()[index].idcoordinacion;
        var idefiscal = recordsAfterPagingAndSorting()[index].idefiscal;
        var concepto = recordsAfterPagingAndSorting()[index].concepto;
        var reversado = recordsAfterPagingAndSorting()[index].reversado;
        var montocompromiso = recordsAfterPagingAndSorting()[index].montocompromiso;
        var ubicacion = recordsAfterPagingAndSorting()[index].ubicacion;
        var status = recordsAfterPagingAndSorting()[index].status;
        var montoiva = recordsAfterPagingAndSorting()[index].montoiva;
        var fechafactura = recordsAfterPagingAndSorting()[index].fechafactura;
        var nrofactura = recordsAfterPagingAndSorting()[index].nrofactura;
        var nrocontrol = recordsAfterPagingAndSorting()[index].nrocontrol;
        var idusuario_crea = recordsAfterPagingAndSorting()[index].idusuario_crea;
        var fecha_crea = recordsAfterPagingAndSorting()[index].fecha_crea;
        var fecha_reverso = recordsAfterPagingAndSorting()[index].fecha_reverso;
        var idusuario_reversa = recordsAfterPagingAndSorting()[index].idusuario_reversa;
        var idtipopago = recordsAfterPagingAndSorting()[index].idtipopago;
        var iddatpresu = recordsAfterPagingAndSorting()[index].iddatpresu;

        var datos = [];
        datos.push({
            idcompromiso,
            tipo,
            referencia,
            fecha,
            idproveedor,
            idcoordinacion,
            idefiscal,
            concepto,
            reversado,
            montocompromiso,
            ubicacion,
            status,
            montoiva,
            fechafactura,
            nrofactura,
            nrocontrol,
            idusuario_crea,
            fecha_crea,
            fecha_reverso,
            idusuario_reversa,
            idtipopago,
            iddatpresu,
        });
        setValues(datos);

    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {
                seleccionarCompromisos()
            }}
        >
            <Modal.Header className='header-azulGradiant'>
                <h3>Seleccionar Compromiso</h3>
                <a ref={btnCancela} 
                    onClick={cancelar}>
                   salir <i className="far fa-times"></i>
                </a>
            </Modal.Header>
            <Modal.Body  className="">
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="input-group input-group-sm mb-3 m-0 col-5">
                    <input type='text'
                        onChange={handleSearch} className="form-control rounded-pill search-input" />
                </div>
                <div style={{height:'300px'}} className="overflow-auto col-12 m-0 p-0">
                    <TblContainer >
                        <TblHead />
                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)} >
                                        <td className='py-2 text-center' style={{ width: '60px' }}>{item.idcompromiso}</td>
                                        <td className='py-2 text-center' style={{ width: '250px' }}>{item.concepto}</td>
                                        <td className='py-2 text-right' style={{ width: '80px' }}>{formatMoneda(item.montocompromiso.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer className='footer-azulGradiant'>
                <button className="btn btn-sm btnPrimary-azulgradiant rounded" 
                    disabled={activo} 
                    onClick={selectCompro}>
                    <i className="fas fa-check-circle"> Aceptar</i> 
                </button>
                <button ref={btnCancela} 
                    onClick={cancelar} 
                    className="btn btn-sm btnSecondary-azulGradiant rounded">
                    <i className="fas fa-window-close"> Cancelar</i>
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoCompromisosUbicacion;